import { svg as utilSvg } from '../utils/svg.js';
import { dataSeries } from '../dataSeries.js';

/**
 *
 * @module gui/legendChoropleth
 */
export const legendChoropleth = {

  /**
   * Class to be added to the choropleth legend when hovered over a region.
   * @type String
   */
  _cssClHighlight: 'active',

  /**
   * Create and return the table.
   * @param {DataSeries} data
   * @return {HTMLTableElement}
   */
  create (data) {
    return this._createTable(data);
  },

  /**
   * Initialize the static part of the legend.
   * @private
   */
  _initDom () {},

  /**
   * Highlight the item in the table (list) related to the active region.
   * @param {RegionEnterEvent} evt
   * @returns {void}
   */
  highlight (evt) {
    const regionId = evt.detail.regionId;
    this.unhighlight();
    const item = document.getElementById('legendItem-' + regionId);
    if (item !== null) { // a restriction on the region might be set
      item.classList.add(this._cssClHighlight);
    }
  },

  /**
   * Revert the highlighted state to the normal state.
   */
  unhighlight () {
    document.querySelectorAll('.legend-data-table tr.' + this._cssClHighlight)
      .forEach(item => {
        item.classList.remove(this._cssClHighlight);
      });
  },

  /**
   * Create the table with the values.
   * @returns {HTMLTableElement}
   * @private
   * @param {DataSeries} data
   */
  _createTable (data) {
    const table = document.createElement('table');
    table.classList.add('legend-data-table');

    let td, str;
    data.series.forEach((item) => {
      const tr = document.createElement('tr');
      tr.id = 'legendItem-' + item.id;

      // create the td for the color
      td = this.createTdColor(item.color);
      tr.append(td);

      // create the td for the value and error label
      str = dataSeries.createStr(item, false);
      td = this.createTdText(str);
      tr.append(td);

      // create the td for the region label
      td = this.createTdText(item.label);
      tr.append(td);

      table.append(tr);
    });

    return table;
  },

  /**
   * Create a td containing a color box.
   * @param {String } color css hex color
   * @return {HTMLTableCellElement}
   */
  createTdColor (color) {
    const td = document.createElement('td');
    const box = document.createElement('div');
    box.classList.add('legend-color-marker');
    box.style.backgroundColor = color;
    td.append(box);

    return td;
  },

  /**
   * Create a td containing text.
   * @param {String} txt
   * @return {HTMLTableCellElement}
   */
  createTdText (txt) {
    const td = document.createElement('td');
    td.textContent = txt;

    return td;
  },

  /**
   * Export the legend data as SVG.
   * @return {SVGGElement}
   * @private
   */
  _exportDataSvg () {
    const svg = utilSvg.create('svg', {
      class: 'export tempy'
    });
    const g = utilSvg.create('g');
    const g1 = utilSvg.create('g');
    const g2 = utilSvg.create('g');
    const g3 = utilSvg.create('g');
    const txt = utilSvg.createText(0, 0, 'dummy');
    g.append(g1, g2, g3, txt);
    svg.append(g);
    this.domNode.append(svg);

    let txtHeight = txt.getBBox();
    txtHeight = txtHeight.height;

    let x, y, w, padding, y1, bbox;
    x = 0;
    y = 0;
    w = 16;
    padding = w / 2;
    this.rowData.series.forEach(item => {
      let txt;

      y += w;
      if (y1 === undefined) {
        y1 = y;
      }
      const rect = utilSvg.createRectangle(0, y, w, w, {
        fill: item.color,
        stroke: '#666',
        'stroke-width': 1
      });
      g1.append(rect);

      x = w + padding;
      txt = utilSvg.createText(x, y + 1 + w / 2, dataSeries.createStr(item, false), {
        'text-anchor': 'end',	// align the label to the right
        'dominant-baseline': 'middle'
      });
      g2.append(txt);

      x += 2 * padding;
      const label = utilSvg.createText(x, y + 1 + w / 2, item.label, {
        'dominant-baseline': 'middle'
      });
      g3.append(label);

      y += w / 2;
    });

    bbox = g2.getBBox();
    utilSvg.translate(g2, Math.ceil(bbox.width + padding), 0);
    utilSvg.translate(g3, Math.ceil(bbox.width + padding), 0);
    utilSvg.translate(g3, Math.ceil(bbox.width + padding), 0);
    svg.remove();

    x = x + Math.ceil(bbox.width);
    y += w / 2;
    const line = utilSvg.createLine(x, y1, x, y, {
      stroke: '#666',
      'stroke-width': 1
    });
    g1.append(line);

    return g;
  }
};